<div class="top-corner">
  <div style="float:left" class="input-group">
    <a class="navbar-item">
    </a>
  </div>
</div><br><br><br><br>
<div class="login-form mt-5">
  <form [formGroup]="userForm" class="text-center">
    <h2 class="text-center title">{{ "TITLE.LOGIN" | translate }}</h2>
    <div class="form-row" style="margin-bottom: -12px!important;">
      <div class="form-group col-md-4">
        <select id="identificationDocumentSelect"
                class="form-control custom-width-select"
                formControlName="identificationdocument"
                (change)="changeDocumentValidator()">
          <option *ngFor="let iddocument of identificationdocuments"
                  [ngValue]="iddocument.code">{{iddocument.code | translate}}</option>
        </select>
      </div>
      <div class="form-group {{!miniLoading ? 'col-md-8' : 'col-md-6'}}">
        <input type="text"
               class="form-control"
               formControlName="documentNumber"
               placeholder="{{ 'LABEL.DOCUMENT-NUMBER' | translate }}"
               [class.is-invalid]="isInvalidControl('documentNumber')"
               (keyup.enter)="login()">
        <small *ngIf="isInvalidControl('documentNumber')"
               class="text-danger">
          {{getErrorMessageBy('documentNumber')}}
        </small>
      </div>
      <div class="form-group col-md-2 text-right" *ngIf="miniLoading">
        <div class="spinner-border text-dark" role="status">
          <span class="sr-only">{{ "MESSAGE.LOADING" | translate }}...</span>
        </div>
      </div>
    </div>
    <div class="form-row mt-2" *ngIf="showEmailField">
      <div class="form-group col-md-11">
        <input type="text"
               class="form-control"
               formControlName="email"
               placeholder="{{ 'LABEL.E-MAIL' | translate }}"
               [class.is-invalid]="isInvalidControl('email')"
               (keyup.enter)="login()">
        <small *ngIf="isInvalidControl('email')"
               class="text-danger">
          {{getErrorMessageBy('email')}}
        </small>
      </div>
      <div class="col-md-1">
        <label class="font-weight-bold mt-2 text-center" [ngbTooltip]="tipObs" container="body">?</label>
      </div>
    </div>
    <div class="text-center mb-2">
      <a href="javascript:;"
         class="{{successQuery && validRequiredInfo? '' : 'disabled'}}"
         (click)="requestVerificationCode()">{{ "LINK.REQUEST-VERIFICATION-CODE" | translate }}</a>
    </div>
    <div class="form-group">
      <div class="input-group">
        <input [type]="fieldTextType ? 'text' : 'password'"
               class="form-control"
               formControlName="password"
               placeholder="{{ 'LABEL.VERIFICATION-CODE' | translate }}"
               [class.is-invalid]="isInvalidControl('password')"
               (keyup.enter)="login()"
               [attr.disabled]="!requestedVerCode ? '' : null">
        <div class="input-group-append">
                <span class="input-group-text">
                <i class="fa {{fieldTextType?'fa-eye':'fa-eye-slash'}}"
                   (click)="toggleFieldTextType()"></i>
              </span>
        </div>
      </div>
      <small *ngIf="isInvalidControl('password')"
             class="text-danger">
        {{getErrorMessageBy('password')}}
      </small>
    </div>
    <div class="form-group">
      <button type="button" class="btn btn-success btn-block" (click)="login()"><i class="fa fa-sign-in" aria-hidden="true"></i> {{ "BUTTON.SIGN-IN" | translate }}</button>
      <br>
      <div class="text-center">
        <small>{{ "MESSAGE.FOR-LOGIN-USING-USERNAME-AND-PASSWORD-CLICK" | translate }} <a [routerLink]="'/login'">{{ "LINK.HERE" | translate }}</a></small>
      </div>
    </div>
  </form>
</div>
<app-loading *ngIf="loading"></app-loading>
<ng-template #tipObs>{{ "MESSAGE.EXIST-MULTIPLE-EMAILS-ASSOCIATED-WITH-DOCUMENT-NUMBER" | translate }}
</ng-template>
